import { render, staticRenderFns } from "./CustomFormGroup.vue?vue&type=template&id=b6519eac&"
import script from "./CustomFormGroup.vue?vue&type=script&lang=js&"
export * from "./CustomFormGroup.vue?vue&type=script&lang=js&"
import style0 from "./CustomFormGroup.vue?vue&type=style&index=0&id=b6519eac&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6519eac')) {
      api.createRecord('b6519eac', component.options)
    } else {
      api.reload('b6519eac', component.options)
    }
    module.hot.accept("./CustomFormGroup.vue?vue&type=template&id=b6519eac&", function () {
      api.rerender('b6519eac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/CustomFormGroup.vue"
export default component.exports